if (!customElements.get('slowko-gallery')) {
  customElements.define('slowko-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.slowko-gallery-track');
      this.slides = Array.from(this.querySelectorAll('.slowko-gallery-slide'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-index]'));
      this.previous = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.count = this.querySelector('[data-gallery-count]');
      if (!this.track || !this.slides.length) return;
      this.index = 0;
      this.querySelector('.slowko-gallery-controls').hidden = this.slides.length < 2;
      this.previous.addEventListener('click', () => this.go(this.index - 1));
      this.next.addEventListener('click', () => this.go(this.index + 1));
      this.thumbs.forEach((button, index) => button.addEventListener('click', () => this.go(index)));
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update(Math.round(this.track.scrollLeft / this.track.clientWidth)));
      }, { passive: true });
      this.editorSelect = event => {
        const slide = event.target.closest('.slowko-gallery-slide');
        const index = this.slides.indexOf(slide);
        if (index >= 0) this.go(index, false);
      };
      this.addEventListener('shopify:block:select', this.editorSelect);
      this.resize = new ResizeObserver(() => this.go(this.index, false));
      this.resize.observe(this.track);
      this.update(0);
    }
    go(index, animate = true) {
      const next = Math.max(0, Math.min(this.slides.length - 1, index));
      const behavior = animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant';
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior });
      this.update(next);
    }
    update(index) {
      this.index = Math.max(0, Math.min(this.slides.length - 1, index));
      this.thumbs.forEach((button, i) => button.setAttribute('aria-current', String(i === this.index)));
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.slides.length - 1;
      this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      this.removeEventListener('shopify:block:select', this.editorSelect);
    }
  });
}
